import { Card, Grid, Typography, useTheme } from '@mui/material';
import { Pie, PieChart } from 'recharts';

import ChipCards from '../dependencies/ChipCards/ChipCards';
import NoShipmentsYet from '../NoShipmentsYet/NoShipmentsYet';
import useShipmentDelivered from './useShipmentDelivered';

const ShipmentDelivered = () => {
  const theme = useTheme();
  const hook = useShipmentDelivered();

  return (
    <Card sx={{ p: 3, borderRadius: 3, boxShadow: 2, height: '100%' }}>
      <Typography variant="body1" sx={{ fontWeight: 600, mb: '1rem' }}>
        Total de envíos entregados: <strong>{hook.data.totalDelivered}</strong>
      </Typography>
      {hook.data.data?.delivered.length === 0 ? (
        <NoShipmentsYet />
      ) : (
        <Grid container padding="1rem" alignItems="center">
          <Grid size={{ xxs: 6 }}>
            <PieChart width={200} height={250}>
              <Pie
                data={hook.data.data?.delivered}
                dataKey="count"
                nameKey="deliveryType"
                cx="50%"
                cy="50%"
                innerRadius={40}
                outerRadius={80}
                fill={theme.palette.primary.main}
              />
            </PieChart>
          </Grid>
          <Grid
            size={{ xxs: 6 }}
            alignItems="center"
            display="flex"
            flexDirection="column"
            gap="1rem"
          >
            {hook.data.data?.delivered?.map((entry) => (
              <ChipCards
                color={theme.palette.primary.main}
                text={entry.deliveryType}
                quantity={entry.count}
              />
            ))}
          </Grid>
        </Grid>
      )}
    </Card>
  );
};

export default ShipmentDelivered;
